module.exports = __webpack_public_path__ + "static/media/delivery-truck.2847bbb7.gif";